
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 19,
  viewBox: "0 0 19 19"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h18.24v18.24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero",
  d: "m13.704 12.629 3.255 3.254-1.076 1.076-3.254-3.255A6.842 6.842 0 0 1 1.52 8.36c0-3.776 3.064-6.84 6.84-6.84a6.842 6.842 0 0 1 5.344 11.109zm-1.525-.564A5.3 5.3 0 0 0 13.68 8.36c0-2.94-2.381-5.32-5.32-5.32-2.94 0-5.32 2.38-5.32 5.32 0 2.939 2.38 5.32 5.32 5.32a5.3 5.3 0 0 0 3.705-1.501l.114-.114z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"19\" height=\"19\" viewBox=\"0 0 19 19\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <path d=\"M0 0L18.24 0 18.24 18.24 0 18.24z\" transform=\"translate(-329 -149) translate(329 149)\"/>\r\n                <path fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\" d=\"M13.704 12.629l3.255 3.254-1.076 1.076-3.254-3.255c-1.211.97-2.717 1.498-4.269 1.496-3.776 0-6.84-3.064-6.84-6.84s3.064-6.84 6.84-6.84 6.84 3.064 6.84 6.84c.002 1.552-.526 3.058-1.496 4.269zm-1.525-.564c.965-.992 1.503-2.321 1.501-3.705 0-2.94-2.381-5.32-5.32-5.32-2.94 0-5.32 2.38-5.32 5.32 0 2.939 2.38 5.32 5.32 5.32 1.384.002 2.713-.536 3.705-1.501l.114-.114z\" transform=\"translate(-329 -149) translate(329 149)\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-search.f725c293feb48ff446bce25cdd2b403b.svg"),
        {
          React: SvgIconsSearch,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      